(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-beneficios"] && !Shopify.designMode) return;
  try {
    
  class AmTicker extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.am-benef__track');
      this.items = Array.from(this.querySelectorAll('.am-benef__item'));
      this.dots = Array.from(this.querySelectorAll('.am-benef__dot'));
      this.interval = parseInt(this.dataset.autoplay || '0', 10);
      this.index = 0;
      if (this.dots.length) this.setActive(0);
      this.track && this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.interval > 0 && !reduce && window.matchMedia('(max-width: 749px)').matches) {
        this.start();
        this.addEventListener('pointerdown', () => this.stop());
      }
    }
    setActive(i) {
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }
    onScroll() {
      if (!this.track) return;
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (i !== this.index) { this.index = i; this.setActive(i); }
    }
    start() {
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.items.length;
        const target = this.items[this.index];
        if (target) this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        this.setActive(this.index);
      }, this.interval);
    }
    stop() { clearInterval(this.timer); }
    disconnectedCallback() { this.stop(); }
  }
  if (!customElements.get('am-ticker')) customElements.define('am-ticker', AmTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-footer"]) return;
  try {
    
  /* Acordeão das colunas no mobile. Sem JS as colunas ficam abertas (o `hidden`
     só é aplicado aqui), então o conteúdo nunca some por falta de script. */
  (function () {
    var MQ = window.matchMedia('(max-width: 767px)');

    function panelOf(btn) {
      return document.getElementById(btn.getAttribute('aria-controls'));
    }

    function sync() {
      var mobile = MQ.matches;
      document.querySelectorAll('.am-footer__toggle[data-am-accordion]').forEach(function (btn) {
        var panel = panelOf(btn);
        if (!panel) return;
        btn.disabled = !mobile;
        btn.setAttribute('aria-expanded', String(!mobile));
        panel.hidden = mobile;
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.am-footer__toggle[data-am-accordion]');
      if (!btn || btn.disabled) return;
      var panel = panelOf(btn);
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    });

    MQ.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-hero"] && !Shopify.designMode) return;
  try {
    
  class AmHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.am-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.am-hero__dot'));
      this.index = 0;
      if (!this.slides.length) return;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = parseInt(this.dataset.speed || '6000', 10);
      this.auto = this.dataset.autoplay === 'true';
      this.querySelector('.am-hero__arrow--prev')?.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      this.querySelector('.am-hero__arrow--next')?.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
      this.dots.forEach(d => d.addEventListener('click', () => { this.go(parseInt(d.dataset.goto, 10)); this.restart(); }));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.start(); });
      this.onMotionChange = () => { this.stop(); this.go(this.index); this.start(); };
      this.reducedMotion.addEventListener('change', this.onMotionChange);
      this.go(0);
      this.start();
    }
    go(i) {
      const n = this.slides.length;
      this.index = (i % n + n) % n;
      this.slides.forEach((s, k) => {
        const on = k === this.index;
        s.toggleAttribute('data-active', on);
        s.inert = !on;
        s.setAttribute('aria-hidden', String(!on));
        const v = s.querySelector('video');
        if (v) { on && !this.reducedMotion.matches ? v.play?.().catch(() => {}) : v.pause?.(); }
        const frame = s.querySelector('iframe[data-src]');
        if (frame) {
          if (on && !this.reducedMotion.matches) { if (!frame.hasAttribute('src')) frame.src = frame.dataset.src; }
          else frame.removeAttribute('src');
        }
      });
      this.dots.forEach((d, k) => { d.classList.toggle('is-active', k === this.index); d.setAttribute('aria-pressed', String(k === this.index)); });
    }
    start() { if (!this.auto || this.slides.length < 2 || this.reducedMotion.matches || this.contains(document.activeElement)) return; this.stop(); this.timer = setInterval(() => this.go(this.index + 1), this.speed); }
    stop() { clearInterval(this.timer); }
    restart() { this.stop(); this.start(); }
    disconnectedCallback() { this.stop(); this.reducedMotion?.removeEventListener('change', this.onMotionChange); this.querySelectorAll('video').forEach(video => video.pause()); }
  }
  if (!customElements.get('am-hero-slideshow')) customElements.define('am-hero-slideshow', AmHeroSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
